jQuery(function( $ ) {
    "use strict"

    sb_when( '#member-map', function() {

        const map       = $( '#member-map' ),
            states      = $( '#member-map-container' ).data( 'states' ).split( ',' ).map( s => s.trim() ),
            mapWidth    = map.innerWidth(),
            mapHeight   = map.innerHeight(),
            mapPos      = map.position(),
            mapPosX     = mapPos.left,
            mapPosY     = mapPos.top,
            overlays = $( '#member-map-overlays' );

        map.find( '.state' ).each( function() {
            const state     = $( this ),
                name        = state.data( 'name' ),
                postalCode  = state.data( 'postal-code' ),
                statePos    = state.position(),
                statePosX   = state.offset().left - map.offset().left,
                statePosY   = state.offset().top - map.offset().top,
                stateWidth  = state.find( 'path' )[0].getBoundingClientRect().width,
                stateHeight = state.find( 'path' )[0].getBoundingClientRect().height,
                xOffset     = state.data( 'x-offset' ) ? state.data( 'x-offset' ) : 0,
                yOffset     = state.data( 'y-offset' ) ? state.data( 'y-offset' ) : 0,
                left        = ( statePosX + stateWidth / 2 ) / mapWidth * 100 + xOffset,
                top         = ( statePosY + stateHeight / 2  ) / mapHeight * 100 + yOffset,
                index       = states.indexOf( postalCode );

            state.on( 'click', function(e) {
                e.preventDefault();
            });

            if ( -1 != index ) {

                state.addClass( 'active-state' );

                overlays.append( '<div style="left:' + left + '%; top:' + top + '%;">'
                    + '<div class="logo" ></div>'
                    + '</div>' );

            }

        });


    });


});
